import {
  Grid,
  FormControl,
  Typography,
  TextField,
  FormHelperText,
  Autocomplete,
} from "@mui/material";
import React, { memo, useEffect, useState } from "react";
import BoxLeftContent from "../../components/BoxLeftContent/BoxLeftContent";
import HeaderPage from "../../components/HeaderPage/Index";
import { isMobile } from "react-device-detect";
import {
  getData,
  storeData,
  checkEditPage,
  callChoice,
} from "../../utils/GlobalHelper";
import Loading from "../../components/loading/loading";
import HeaderRight from "../../components/BoxRightContent/HeaderRight";
import ButtonRight from "../../components/BoxRightContent/ButtonRight";
import Configs from "../../constants/Configs";
import GlobalApi from "../../utils/GlobalApi";
import PanelScrollBar from "../../components/BoxRightContent/PanelScrollBar";
import { isEmpty } from "lodash";
import CustomList from "../../components/BoxRightContent/CustomList";
import DialogError from "../../components/CustomDialog/DialogCustoms";
import { API_CODE_SUCCESS } from "../../constants/CommonConstant";

const header = {
  headers: {
    "Content-Type": "application/json",
  },
};
var pp = [];
var txtpp = "";
var am = {};

const InvestInfoPurpose = (props) => {
  const [lang, setLang] = useState(getData("lang"));
  const [translations, setTranslations] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isModalError, setIsModalError] = useState(false);
  const [modalErrorTitle, setModalErrorTitle] = useState("ขออภัย");
  const [modalErrorDes, setModalErrorDes] = useState(
    "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง",
  );
  const [isCheck, setIsCheck] = useState(false);
  const [editUrl, setEditUrl] = useState(false);
  const [jumpPage, setJumpPage] = useState(false);
  // Purpose
  const [purpose, setPurpose] = useState([]);
  const [textPurpose, setTextPurpose] = useState("");
  const [isTextPurpose, setIsTextPurpose] = useState(false);
  // Invest
  const [amount, setAmount] = useState({});
  // Text Error
  const [amountError, setAmountError] = useState("");
  const [textPurposeError, setTextPurposeError] = useState("");
  // Options data
  const [purposes, setPurposes] = useState([]);
  const [amounts, setAmounts] = useState([]);
  // LocalStorage data
  const head_token = getData("HeaderManp")
    ? getData("HeaderManp")?.head_token
    : "";
  const f3 = getData("f3_purpose_invest");
  const f3Source = getData("f3_source_income");
  const f3Asset = getData("f3_asset");
  const f3Career = getData("f3_career");
  const checkuserinfo = getData("checkuserinfo");
  const questions = getData("questionsAnswer");
  const pageAgree = getData("page_agree");
  const idc = getData("idc");
  const idcAddr = getData("f2_idc_address");
  const curAddr = getData("f2_current_address");
  const workAddr = getData("f2_workplace_address");
  const docAddr = getData("f2_document_address");
  const suit = getData("suitability");
  const status = getData("family_status");
  const childList = getData("childList");
  let snapIdCard = getData("uploadImage");

  const checkJumpPage = async () => {
    await getImage();
    let productChoice = false;
    await callChoice(head_token).then((res) => {
      if (!isEmpty(res)) {
        res.forEach((e) => {
          e.items.forEach((item) => {
            if (item.selected === 1) productChoice = true;
          });
        });
      }
    });

    if (
      isEmpty(checkuserinfo) ||
      isEmpty(questions) ||
      isEmpty(pageAgree) ||
      pageAgree.termandcon !== 1 ||
      pageAgree.pdpa !== 1 ||
      isEmpty(snapIdCard) ||
      isEmpty(idc) ||
      isEmpty(idcAddr) ||
      isEmpty(curAddr) ||
      isEmpty(workAddr) ||
      isEmpty(docAddr) ||
      isEmpty(f3Career) ||
      !productChoice ||
      isEmpty(suit) ||
      isEmpty(status) ||
      isEmpty(childList?.data) ||
      isEmpty(f3Source)
    ) {
      return true;
    } else {
      return false;
    }
  };
  const getImage = async () => {
    setIsLoading(true);
    var postData = {
      head_token,
    };
    const queryString = new URLSearchParams(postData).toString();
    let getImage_url = `${Configs.baseURL}/api/getupload?` + queryString;
    try {
      await GlobalApi.get(getImage_url, header)
        .then(async (res) => {
          setIsLoading(false);
          if (res.data.api_status === "1") {
            if (res.data.data.length > 0) {
              res.data.data.forEach((element) => {
                if (element.tb_image_page === "uploadImage") {
                  snapIdCard = element.tb_image_type + element.tb_image_base64;
                }
              });
            }
          }
        })
        .catch((er) => {
          setIsLoading(false);
        });
    } catch (error) {
      setIsLoading(false);
    }
    return;
  };
  const checkEditUrl = async () => {
    checkEditPage().then((res) => {
      res ? setEditUrl(true) : setEditUrl(false);
    });
  };
  const callGetPurpose = async () => {
    setIsLoading(true);
    try {
      await GlobalApi.get(`${Configs.baseAPIURL03}/constant/purpose`)
        .then((res) => {
          setIsLoading(false);
          setPurposes([...res?.data?.Data]);
        })
        .catch((er) => {
          setIsLoading(false);
        });
    } catch (error) {
      setIsLoading(false);
    }
  };
  const callGetAmount = async () => {
    setIsLoading(true);
    try {
      await GlobalApi.get(`${Configs.baseAPIURL03}/constant/invest`)
        .then((res) => {
          if (res.data) {
            let data = res.data.Data;
            setAmounts(data);
            if (!isEmpty(f3.f3_invest)) {
              data.forEach((ele) => {
                if (ele.Id === f3.f3_invest) {
                  setAmount(ele);
                  am = ele;
                }
              });
            }
            setIsLoading(false);
          }
        })
        .catch((er) => {
          setIsLoading(false);
        });
    } catch (error) {
      setIsLoading(false);
    }
  };
  const onInitData = async () => {
    let isHave = false;
    if (!isEmpty(f3)) {
      var oldChoices = [];
      if (!isEmpty(f3["purpose_json"])) {
        const purposeJson = f3["purpose_json"];
        purposeJson.forEach((ele) => {
          if (ele.SAfpp_SAmpp_Id === "10") {
            oldChoices.push(ele.SAfpp_SAmpp_Id);
            isHave = true;
            let oldTxtChoice = "";
            if (!isEmpty(ele.SAfpp_Text)) {
              oldTxtChoice = ele.SAfpp_Text;
              isHave = true;
            } else {
              oldTxtChoice = "";
            }
            setTextPurpose(oldTxtChoice);
            txtpp = oldTxtChoice;
          } else {
            oldChoices.push(ele.SAfpp_SAmpp_Id);
            isHave = true;
          }
        });
      }
      setPurpose(oldChoices);
      pp = oldChoices;

      if (isHave) {
        setIsCheck(true);
      }
    }
  };
  const handleChangeAmount = (e, value) => {
    if (!isEmpty(value)) {
      setAmount(value);
    } else {
      setAmount({});
    }
    am = value;
    checkEnable();
  };
  const handleChangePurpose = (name, id, check) => {
    const data = [...purpose];
    if (name.includes("Other")) {
      setTextPurpose("");
      setTextPurposeError("");
    }
    if (check) {
      data.push(id.toString());
      setPurpose(data);
      pp = data;
      if (name.includes("Other")) {
        setIsTextPurpose(true);
      }
    } else {
      if (name.includes("Other")) {
        setIsTextPurpose(false);
      }
      const newData = data.filter(function (item) {
        return item !== id.toString();
      });
      !isEmpty(newData) ? setPurpose(newData) : setPurpose([]);
      pp = newData;
    }
    checkEnable();
  };
  const handleChangeTextPurpose = (e) => {
    setIsTextPurpose(true);
    setTextPurposeError("");
    if (!isEmpty(e)) {
      setTextPurpose(e.target.value);
    } else {
      setTextPurpose("");
    }
    txtpp = e.target.value;
    checkEnable();
  };
  const checkEnable = () => {
    if (isEmpty(pp) || (pp.includes("10") && isEmpty(txtpp)) || isEmpty(am)) {
      setIsCheck(false);
    } else {
      setIsCheck(true);
    }
  };
  const setTextSummary = async (data) => {
    let text = {
      amount: amount.ThName,
    };
    purpose?.forEach((i) => {
      purposes?.forEach((j) => {
        if (
          i === j.SAmpp_Id.toString() &&
          j.SAmpp_Name.includes("เพื่อการลงทุนระยะสั้น")
        ) {
          text.short = j.SAmpp_Name;
        }
        if (
          i === j.SAmpp_Id.toString() &&
          j.SAmpp_Name.includes("เพื่อการลงทุนระยะยาว")
        ) {
          text.long = j.SAmpp_Name;
        }
        if (
          i === j.SAmpp_Id.toString() &&
          j.SAmpp_Name.includes("เพื่อสิทธิประโยชน์ทางภาษี")
        ) {
          text.tax = j.SAmpp_Name;
        }
        if (
          i === j.SAmpp_Id.toString() &&
          j.SAmpp_Name.includes("เพื่อการเกษียณ")
        ) {
          text.retire = j.SAmpp_Name;
        }
        if (i === j.SAmpp_Id.toString() && j.SAmpp_Name.includes("อื่นๆ")) {
          text.other = textPurpose;
        }
      });
    });

    storeData("text_invest_purpose", text);
    storeData("f3_purpose_invest", data);
    if (editUrl) {
      let preData = {
        head_token,
        f3_source: f3Source.f3_source,
        f3_source_text: f3Source.f3_source_text,
        f3_by_employee: f3Source.f3_by_employee,
        f3_by_heritage: f3Source.f3_by_heritage,
        f3_by_saving: f3Source.f3_by_saving,
        f3_by_invest: f3Source.f3_by_invest,
        f3_by_retired: f3Source.f3_by_retired,
        f3_by_private_business: f3Source.f3_by_private_business,
        f3_by_other: f3Source.f3_by_other,
        f3_by_other_text: f3Source.f3_by_other_text,

        f3_invest: data.f3_invest,
        purpose_json: data.purpose_json,

        f3_valuable: f3Asset.f3_valuable,
        f3_outcome: f3Asset.f3_outcome,

        f3_career: f3Career.f3_career,
        f3_career_text: f3Career.f3_career_text,
        f3_business: !isEmpty(f3Career.f3_business) ? f3Career.f3_business : "",
        f3_business_text: f3Career.f3_business_text,
        f3_income: f3Career.f3_income,
        f3_position: f3Career.f3_position,
        f3_officename: f3Career.f3_officename,
        f3_own: "1",
      };
      postData(preData);
    } else {
      props.history.push("/invest_info_asset");
    }
  };
  const postData = async (data) => {
    setIsLoading(true);
    try {
      GlobalApi.post(
        `${Configs.baseAPIURL03}/form/career_and_financial/manp`,
        data,
        header,
      )
        .then((res) => {
          setIsLoading(false);
          if (res.data.Data[0][0].IsSuccess === 1) {
            storeData("editPage", "invest_purpose");
            props.history.push("/summary");
          }
        })
        .catch((e) => {
          setModalErrorDes(e);
          setIsModalError(true);
          setIsLoading(false);
        });
    } catch (error) {
      setModalErrorDes(error);
      setIsModalError(true);
      setIsLoading(false);
    }
  };
  const handleNext = async (e) => {
    e.preventDefault();
    let valid = await validate();
    if (valid) {
      let prepareData = {
        f3_invest: amount.Id.toString(),
        purpose_json: [],
      };
      if (!isEmpty(purpose)) {
        purpose.forEach((ele) => {
          let setPurpose = {
            SAfpp_SAmpp_Id: "",
            SAfpp_Text: "",
          };
          setPurpose.SAfpp_SAmpp_Id = ele.toString();
          setPurpose.SAfpp_Text = ele === "10" ? textPurpose : "";
          prepareData["purpose_json"].push(setPurpose);
        });
        await setTextSummary(prepareData);
      }
    }
  };
  const validate = async () => {
    let valid = true;
    if (isEmpty(amount)) {
      setAmountError("กรุณาระบุจำนวนเงิน");
      valid = false;
    }
    if (!isEmpty(purpose)) {
      purpose.forEach((ele) => {
        if (ele === "10" && isEmpty(textPurpose)) {
          valid = false;
          setTextPurposeError("กรุณาระบุวัตถุประสงค์การลงทุนอื่น ๆ");
        }
      });
    }
    return valid;
  };
  useEffect(() => {
    checkJumpPage().then((res) => {
      if (res) {
        setJumpPage(true);
      } else {
        const translation = getData("Translations");
        if (!isEmpty(translation)) {
          setTranslations(translation);
        } else {
          props.history.push("/");
        }
        checkEditUrl();
        callGetPurpose();
        callGetAmount();
        onInitData();
      }
    });
  }, []);

  return (
    <>
      {jumpPage ? (
        <Grid className="app-splash-screen"></Grid>
      ) : (
        <>
          <HeaderPage
            title={translations?.[lang]?.purposeInvest?.title}
            onChangeLang={(e) => setLang(e)}
            clickBack={(e) =>
              e ? props.history.push("/invest_info_income") : ""
            }
          />
          <Loading status={isLoading} />
          <Grid className="background-bg">
            <Grid className="section-consent">
              <Grid className={isMobile ? "box-content-mb" : "box-content"}>
                <Grid container className="box-content-main" columns={16}>
                  {!isMobile && (
                    <Grid item xs={7} className="box-left">
                      <BoxLeftContent
                        translations={translations?.[lang]?.purposeInvest}
                        clickBack={(e) =>
                          props.history.push("/invest_info_income")
                        }
                        editUrl={editUrl}
                      />
                    </Grid>
                  )}
                  <Grid
                    item
                    xs={isMobile ? 16 : 9}
                    className={isMobile ? "box-right-mb" : "box-right"}
                  >
                    <Grid className="content">
                      <Grid className="content-main">
                        <Grid
                          className="box-right-content pb-3"
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            height: "100%",
                          }}
                        >
                          {" "}
                          <HeaderRight
                            title={translations?.[lang]?.purposeInvest?.title}
                          />
                          <PanelScrollBar
                            size="full"
                            content={
                              <>
                                <Grid>
                                  <Grid>
                                    <Typography className="text-primary font-weight-bold font-20 ">
                                      {
                                        translations?.[lang]?.purposeInvest
                                          ?.sub_title_1
                                      }
                                    </Typography>
                                  </Grid>
                                  <CustomList
                                    page="purpose"
                                    lang={lang}
                                    data={purposes}
                                    value={purpose}
                                    onChange={handleChangePurpose}
                                  />
                                  {isTextPurpose || !isEmpty(textPurpose) ? (
                                    <Grid className="input-form">
                                      <FormControl
                                        fullWidth
                                        variant="standard"
                                        error
                                      >
                                        <TextField
                                          fullWidth
                                          variant="standard"
                                          value={textPurpose}
                                          placeholder="กรุณาระบุวัตถุประสงค์การลงทุน"
                                          onChange={handleChangeTextPurpose}
                                        />
                                        <FormHelperText className="text-error">
                                          {textPurposeError}
                                        </FormHelperText>
                                      </FormControl>
                                    </Grid>
                                  ) : (
                                    <Grid></Grid>
                                  )}
                                </Grid>
                                <Grid className="choices-box">
                                  <Grid>
                                    <Typography className="text-primary font-weight-bold font-20">
                                      {
                                        translations?.[lang]?.purposeInvest
                                          ?.sub_title_2
                                      }
                                    </Typography>
                                  </Grid>
                                  <Grid className="input-form">
                                    <FormControl
                                      variant="standard"
                                      fullWidth
                                      error
                                    >
                                      <Autocomplete
                                        options={amounts}
                                        value={amount}
                                        getOptionLabel={(option) =>
                                          option.ThName ? option.ThName : ""
                                        }
                                        onChange={(e, value) =>
                                          handleChangeAmount(e, value)
                                        }
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            InputProps={{
                                              ...params.InputProps,
                                              // readOnly: true,
                                            }}
                                            variant="standard"
                                            placeholder="กรุณาเลือก"
                                          />
                                        )}
                                      />
                                      <FormHelperText className="text-error">
                                        {amountError}
                                      </FormHelperText>
                                    </FormControl>
                                  </Grid>
                                </Grid>
                              </>
                            }
                          />{" "}
                          <ButtonRight
                            isDisbled
                            disbled={isCheck}
                            text={
                              editUrl
                                ? "บันทึกการแก้ไข"
                                : translations?.[lang]?.purposeInvest?.next
                            }
                            onNextPage={handleNext}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
};
export default memo(InvestInfoPurpose);
